import { ArrowUp } from "lucide-react";
import { MaskLineInView } from "./motion";
import { LogoMark, scrollToSection } from "./Nav";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-line bg-ink2">
      <div className="mx-auto max-w-[1600px] px-6 pt-16 sm:px-12 lg:px-24">
        <h2 className="text-outline select-none text-center font-serif text-[19vw] font-light uppercase leading-[0.8] tracking-tight lg:text-[15rem]">
          <MaskLineInView>Forbes</MaskLineInView>
        </h2>
        <div className="flex flex-col items-center justify-between gap-6 border-t border-line py-8 sm:flex-row">
          <div className="flex items-center gap-3">
            <LogoMark className="h-6 w-6" />
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-smoke">
              © 2026 Nolan Ryan Forbes — Texas, USA
            </p>
          </div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-smoke">
            Technology · Psychology · The Arts
          </p>
          <button
            data-testid="back-to-top-button"
            onClick={() => scrollToSection("#top")}
            className="group inline-flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.25em] text-ash transition-colors hover:text-vermilion"
          >
            Back to top
            <ArrowUp className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-1" strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </footer>
  );
}